import type { ReactNode, ComponentProps } from 'react';
import { useMemo } from 'react';
import { getCountryStates } from '@ballerine/common';
import { SelectContent } from '../Select';

export const StateSelectContent = ({
  countryCode,
  children,
  ...props
}: Omit<ComponentProps<typeof SelectContent>, 'children'> & {
  countryCode: string;
  children: (state: ReturnType<typeof getCountryStates>[number]) => ReactNode;
}) => {
  const states = useMemo(() => getCountryStates(countryCode), [countryCode]);

  return <SelectContent {...props}>{states.map(state => children(state))}</SelectContent>;
};

StateSelectContent.displayName = 'StateSelectContent';
